import { NewBox as Box, ContentLoader } from "@bca/ui-library";

const LoadingCard: React.FunctionComponent = () => {
  return (
    <Box
      borderRadius="sm"
      marginBottom="md"
      padding="lg"
      paddingTop="md"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        marginBottom="md"
      >
        <ContentLoader
          width="80px"
          height="24px"
          uniqueKey="card-status-loader"
        >
          <rect width={50} height={24} rx={12} ry={12}></rect>
          <rect width={50} height={24} x={24} rx={12} ry={12}></rect>
        </ContentLoader>
        <ContentLoader width="140px" height="24px" uniqueKey="card-date-loader">
          <rect width={110} height={24} rx={8} ry={8}></rect>
          <rect width={110} height={24} x={24} rx={8} ry={8}></rect>
        </ContentLoader>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        height={32}
      >
        <ContentLoader
          width="140px"
          height="24px"
          uniqueKey="card-number-loader"
        >
          <rect width={110} height={24} rx={8} ry={8}></rect>
          <rect width={110} height={24} x={24} rx={8} ry={8}></rect>
        </ContentLoader>
        <ContentLoader
          width="140px"
          height="24px"
          uniqueKey="card-amount-loader"
        >
          <rect width={110} height={24} rx={8} ry={8}></rect>
          <rect width={110} height={24} x={24} rx={8} ry={8}></rect>
        </ContentLoader>
      </Box>
      <Box marginBottom="lg">
        <ContentLoader width="140px" height="24px" uniqueKey="card-type-loader">
          <rect width={110} height={24} rx={8} ry={8}></rect>
          <rect width={110} height={24} x={24} rx={8} ry={8}></rect>
        </ContentLoader>
      </Box>
      <Box display="flex" flexDirection="row" marginTop="md">
        <ContentLoader width="140px" height="24px" uniqueKey="card-vrm-loader">
          <rect width={80} height={24} rx={8} ry={8}></rect>
          <rect width={80} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </Box>
    </Box>
  );
};

export default LoadingCard;
